import { Component, Input, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { CreateTransactionO2OCommand } from 'src/app/core/api/models/create-transaction-o-2-o-command';
import { EventTypes } from 'src/app/core/constants/event-types';
import { TypeCreditChanges } from '../../../../core/api/models/type-credit-changes';
import { TypeTransactions } from '../../../../core/api/models/type-transactions';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { OrganizationTransactionsService } from './../../../../core/api/services/organization-transactions.service';
import { FormPageConfig } from './../../../../core/models/form-page-config.model';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';


@Component({
    selector: 'app-organization-transactions-form',
    templateUrl: './organization-transactions-form.component.html',
    imports: [
        BaseFormModule
    ]
})
export class OrganizationTransactionsFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  @Input() currentOrganization;
  @Input() inputOrganizationId: number = 0;
  formPageConfig: FormPageConfig<any> = {};
  protected currentService = inject(OrganizationTransactionsService);

  model: CreateTransactionO2OCommand = {};
  giverOrganizationId;

  // typeTransaction = TypeTransactions.Increase;
  get TypeTransactions() {
    return TypeTransactions;
  }
  get TypeCreditChanges() {
    return TypeCreditChanges;
  }

  //#endregion

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.disableControls();

    //this.changeTypeTransaction(this.typeTransaction)
  }

  //#region init methods
  initModel(): void {
    this.model.typeTransaction = TypeTransactions.Increase;
  }

  initForm() {
    this.form = new FormGroup({
      amount: new FormControl('', Validators.required),
      currentCredit: new FormControl(''),
      //  giverOrganizationId: new FormControl('', Validators.required),
      currentOrganization: new FormControl(''),
      getterOrganizationId: new FormControl('', Validators.required),
      getterUserId: new FormControl(''),
      organizationName: new FormControl(''),
      outboxId: new FormControl(''),
      // paymentId: new FormControl('', Validators.required),
      typeCreditChange: new FormControl('', Validators.required),
      typeTransaction: new FormControl('', Validators.required),
      description: new FormControl(''),
    });
  }

  disableControls() {
    try {
      this.form.controls['currentOrganization'].disable();
      if (this.inputOrganizationId)
        this.form.get('getterOrganizationId').disable();
      else this.form.get('getterOrganizationId').enable();

      if (this.formPageConfig.isEditMode) {
        this.form.controls['currentCredit'].disable();
        this.form.controls['organizationId'].disable();
        this.form.controls['outboxId'].disable();
        this.form.controls['typeCreditChange'].disable();
        this.form.controls['typeTransaction'].disable();
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  //#endregion

  //#region Api

  //Create
  baseCreateApi(model: CreateTransactionO2OCommand) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .organizationTransactionsCreateTransactionForOrganizationPost({
        body: model,
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: any): void {
    this.baseCreateApi(model);
  }

  //#endregion

  onSubmit() {
    if (!this.isValidForm(this.form, this.tagName)) return;
    if (this.loading) return;

    if (this.inputOrganizationId)
      this.model.getterOrganizationId = this.inputOrganizationId;

    this.baseCreateApi(this.model);
  }
}
